module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[14]13.5937efb.woff2";